import { BookingHeader } from '../BookingHeader';
import './index.css';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="layout-container">
      {/* Background decoration */}
      <div className="layout-background">
        <div className="layout-circle layout-circle-1" />
        <div className="layout-circle layout-circle-2" />
        <div className="layout-circle layout-circle-3" />
      </div>
      
      <BookingHeader />
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
}
